module.exports = __webpack_public_path__ + "static/media/Projektbesuch_.e7e90f75.png";